import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const RepresentativeTitleConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/representative-title",
    component: React.lazy(() => import("./representative-title")),
  },
];
